import { render, staticRenderFns } from "./AnnualWeighing.vue?vue&type=template&id=3e5573a0&scoped=true"
import script from "./AnnualWeighing.vue?vue&type=script&lang=js"
export * from "./AnnualWeighing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5573a0",
  null
  
)

export default component.exports